/**
 * Shared "checking / not authorized" gate, factored out of AdminGenesys.jsx
 * so the new Phase 6/7 pages (review queue, audit log, error log) don't each
 * re-implement the same loading/role check.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

const RequireAdmin = ({ children }) => {
  const navigate = useNavigate();
  const { user, isAuthed, isLoading } = useAuth();
  const isAdmin = isAuthed && user?.role === "admin";

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center text-celestial-muted">…</div>;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-midnight via-surface to-midnight">
        <div className="w-full max-w-md card-celestial rounded-2xl p-8 space-y-4 text-center">
          <ShieldAlert className="w-8 h-8 text-danger mx-auto" />
          <h1 className="text-xl font-display font-bold text-celestial-text">Admin access required</h1>
          <p className="text-sm text-celestial-muted">
            {isAuthed ? "Your account doesn't have admin access." : "Log in with an admin account to manage live config."}
          </p>
          <Button className="btn-celestial rounded-xl" onClick={() => navigate(isAuthed ? "/" : "/login")}>
            {isAuthed ? "Refresh" : "Log in"}
          </Button>
        </div>
      </div>
    );
  }

  return children;
};

export default RequireAdmin;
